// extracted by mini-css-extract-plugin
export default {"sideBtn":"ScrollButton_sideBtn__2Aq4B","animationRoll":"ScrollButton_animationRoll__6piZX"};